//#region libraries
import React, { useEffect, useState } from "react";
import { useParams, useLocation } from "react-router-dom/cjs/react-router-dom.min";
//redux
import { useDispatch, useSelector } from "react-redux";
import { getPaxQuestions, selectPaxQuestions, selectPaxQuestionsStatus } from "_redux/slices/analytics/review-control-panel";
import { getAirportLogo } from "_redux/slices/analytics/reviews";
//custom components
import SurveyPreviewView from "_components/organisms/feedback/survey-preview-view";
//#endregion

const LANGUAGE_LABELS = { en: "English", ar: "Arabic", es: "Spanish" };

// Public preview of a SAVED survey, opened in a new tab from the control panel.
// Fetches the exact language-flattened questions passengers receive, so the preview
// is faithful. Never persists anything.
const SurveyPreview = () => {
    const { iata, surveyId } = useParams();
    const location = useLocation();
    const dispatch = useDispatch();

    const initialLang = new URLSearchParams(location.search).get("lang") || "en";
    const [language, setLanguage] = useState(initialLang);

    const paxQuestions = useSelector(selectPaxQuestions);
    const status = useSelector(selectPaxQuestionsStatus);

    useEffect(() => {
        dispatch(getPaxQuestions({ surveyId, language }));
    }, [language, surveyId]);

    useEffect(() => {
        if (iata) dispatch(getAirportLogo(iata));
    }, [iata]);

    // Prefer the languages the survey document advertises; fall back to the current one.
    const languages = Array.isArray(paxQuestions?.languages) && paxQuestions.languages.length > 0
        ? paxQuestions.languages
        : [{ label: LANGUAGE_LABELS[language] || language.toUpperCase(), value: language }];

    return (
        <div style={{ maxWidth: 1000, margin: "0 auto", padding: "24px 16px" }}>
            <SurveyPreviewView
                questions={paxQuestions?.questions || []}
                languages={languages}
                language={language}
                onLanguageChange={setLanguage}
                loading={status === "loading"}
            />
        </div>
    );
};

export default SurveyPreview;
